// Single source of truth for every CaptiVision fact that appears on the site.
// Prices, links and settings here are lifted from the product's own landing
// page and documentation - if they change there, change them here.

export const APP = {
    name: 'CaptiVision',
    tagline: 'See who is speaking',
    description: 'Live captions and video for Deaf and hard of hearing people',
    copyrightYear: 2026,

    // CaptiVision Client on the App Store. The join page sends people here when
    // they scan a pairing code without the app installed.
    clientAppStoreUrl: 'https://apps.apple.com/us/app/captivision-client/id6811103115',

    // CaptiVision Host on the App Store
    hostAppStoreUrl: 'https://apps.apple.com/us/app/captivision-host/id6811101711',

    // the Synergie Tech support portal, shared with the other apps
    supportUrl: 'https://synergietech.ladesk.com/',

    // the maker's own site, linked from the footer
    companyUrl: 'https://sparemic.app/',

    appleEulaUrl: 'https://www.apple.com/legal/internet-services/itunes/dev/stdeula/',
    manageSubscriptionsUrl: 'https://apps.apple.com/account/subscriptions',
    reportAProblemUrl: 'https://reportaproblem.apple.com'
}

// Every CaptiVision route hangs off BASE, so the site can be moved under a
// path again with one edit. The site is its own app now, so it sits at the root.
// HOME is the landing page - a link cannot point at an empty BASE.
export const BASE = '';
export const HOME = BASE || '/';

// Pricing is public. Set this to false to drop the pricing page at /pricing
// and its nav link, the price on each app, and the terms page's CaptiVision
// Pro subscription section - PRICES below is what they show.
export const SHOW_PRICING = true;

// The TestFlight testing page at /testing. It is unlisted - no page
// links to it - and the link goes out by email. Swap the invite links here when
// a new public link is made, and fill in surveyUrl to turn "the survey" into a link.
export const TESTING = {
    hostInviteUrl: 'https://testflight.apple.com/join/JwCj9gU4',
    cameraInviteUrl: 'https://testflight.apple.com/join/Yayhrz7k',
    surveyUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfyxeafayTTfY6Xgsx1jrxyvoEyCEHthiUL7nYrL4KeY7LlGw/viewform?usp=header'
}

export const LEGAL = {
    companyLegalName: 'Synergie Tech',
    // written as a date, so each language shows it its own way
    effectiveDate: '2026-09-11',
    supportEmail: 'support@captivision.app'
}

// the header nav. `hash` entries live on the landing page, so from any other
// page they have to route home first and then scroll. `key` names the label in
// the strings files; `label` is the English one pages pass as `current`.
export const NAV = [
    { key: 'how', label: 'How it works', to: HOME, hash: 'how' },
    { key: 'apps', label: 'The apps', to: HOME, hash: 'apps' },
    { key: 'story', label: 'Story', to: `${BASE}/story` },
    { key: 'pricing', label: 'Pricing', to: `${BASE}/pricing`, pricing: true },
    { key: 'guide', label: 'User guide', to: `${BASE}/get-started` }
].filter(link => SHOW_PRICING || !link.pricing)

// The landing page's copy - the steps, features and uses among it - is in
// i18n/strings, one file per language.

// The US prices, which must match the App Store listing. Every page that shows
// a price - the pricing page, the guide and the terms - formats these in the
// reader's language, and says that the App Store charges in local currency,
// so prices may differ by country or region.
export const PRICES = {
    currency: 'USD',
    monthly: 9.99,
    yearly: 99.99
}
